import Model from "@/lib/model/model";
import request from "@/lib/request/request";

export class Template extends Model {
  templateId = 0;
  companyId = 0; // 公司id
  env = 1; // 模板场景 1邀请 2通过 3淘汰
  type = 0; // 模板类型 1短信 2邮件 4待定 5提醒
  isSystem = 0; // 是否是系统级别默认模板
  auditStatus = 0; // 审核结果 0:未审核 1:通过 2:拒绝
  auditReason = ""; // 审核驳回原因
  createdTime = "";
  name = ""; // 模板名称
  isDefault = 0; // 是否是公司级别默认模板
  isClose = 0; // 是否关闭发送
  mobileContent = ""; // 短信内容
  emailContentHtml = ""; // 邮件内容
  emailContentTextOnly = ""; //邮件内容 纯文本版
  emailName = ""; // 邮件发件人
  emailSubject = ""; // 邮件主题

  static create(param: Template) {
    return request.post("/aiExam/message/templateCreate", param).then(resp => {
      return resp;
    });
  }

  static get(param: any) {
    return request.post("/aiExam/message/templateGet", param).then(resp => {
      return resp;
    });
  }

  static update(param: any) {
    return request.post("/aiExam/message/templateUpdate", param).then(resp => {
      return resp;
    });
  }

  static del(param: any) {
    return request.post("/aiExam/message/templateDelete", param).then(resp => {
      return resp;
    });
  }

  static getTemplateList(param: any) {
    return request.post("/aiExam/message/templateList", param).then(resp => {
      return resp;
    });
  }
}

export class ExamMsgTemp extends Model {
  examId = 0;
  autoPassMessage = 2;
  autoRefuseMessage = 2;
  autoWaitMessage = null; //面试待定通知是否自动发送
  templateList: Template[] = [];

  public objectArrayClasses() {
    return {
      templateList: Template
    };
  }

  static get(id: number) {
    return request
      .postInterviewApi("hr/exam/message/get", { examId: id })
      .then(res => {
        return res.data;
      });
  }

  static set(param: ExamMsgTemp) {
    return request.postInterviewApi("hr/exam/message/link", param).then(res => {
      return res.data;
    });
  }
}
